export const initialState = {
  attachments: [],
  attachmentsLoading: true,
  tags: [],
  sync: {
    meetings: { inProgress: false, percent: 0 },
  },
};

export const reducer = (state = initialState, action) => {
  switch (action.type) {
    case "SET_SELECTED_WORKFLOW_ID":
      return {
        ...state,
        selectedWorkflowId: action.selectedWorkflowId,
      };
    case "SET_ATTACHMENTS":
      return {
        ...state,
        attachments: action.attachments,
        attachmentsLoading: false,
      };
    case "SET_ATTACHMENTS_LOADING":
      return {
        ...state,
        attachmentsLoading: action.attachmentsLoading,
      };
    case "SET_COMMENTS":
      return {
        ...state,
        comments: action.comments,
      };
    case "SET_CLIENT_SYNC":
      return {
        ...state,
        sync: {
          ...state.sync,
          ...action.sync,
        },
      };
    default:
      return state;
  }
};
export default reducer;
